export const AI_ERROR_MESSAGES = {
	OVERLOADED: 'Claude is currently overloaded. Please try again in a few moments.',
	NOT_FOUND: (model: string) => `Model "${model}" not found. This may be a configuration issue.`,
	AUTH_ERROR: 'Authentication error. Please check your API credentials.',
	RATE_LIMIT: 'Rate limit exceeded. Please try again in a few moments.',
	NETWORK_ERROR: 'Network error. Please check your connection and try again.',
	TIMEOUT: 'Request timed out. The analysis may be taking longer than expected.',
	PAYLOAD_TOO_LARGE: 'Report data is too large. Please reduce the amount of data.',
	GENERIC: 'An error occurred processing your request. Please try again.',
	CURL_ERROR: 'Connection error. Please check your network connection.',
	INVALID_RESPONSE: 'Invalid response from AI service. Please try again.',
	EMPTY_RESPONSE: 'Received empty response from AI service.'
};

export function getErrorMessage(errorType: string, errorMsg?: string): string {
	switch (errorType) {
	case 'overloaded_error':
		return AI_ERROR_MESSAGES.OVERLOADED;
	case 'not_found_error':
		return AI_ERROR_MESSAGES.NOT_FOUND(errorMsg || 'unknown');
	case 'authentication_error':
		return AI_ERROR_MESSAGES.AUTH_ERROR;
	case 'rate_limit_error':
		return AI_ERROR_MESSAGES.RATE_LIMIT;
	case 'curl_error':
		return AI_ERROR_MESSAGES.CURL_ERROR;
	case 'timeout':
		return AI_ERROR_MESSAGES.TIMEOUT;
	case 'payload_too_large':
		return AI_ERROR_MESSAGES.PAYLOAD_TOO_LARGE;
	case 'invalid_response':
		return AI_ERROR_MESSAGES.INVALID_RESPONSE;
	case 'empty_response':
		return AI_ERROR_MESSAGES.EMPTY_RESPONSE;
	default:
		return errorMsg || AI_ERROR_MESSAGES.GENERIC;
	}
}
